@if (spinnerService.loading) {
  <app-spinner />
} 

<router-outlet />
